<template>
  <BasePopup
    :show="show"
    :show-close-button="true"
    @close="$emit('close')"
  >
    <div class="error-popup-content">
      <!-- 粉紅色 error 圖標 -->
      <div class="error-icon">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 31.5C21.595 31.5 22.0941 31.2984 22.4973 30.8952C22.9005 30.492 23.1014 29.9936 23.1 29.4C23.0986 28.8064 22.897 28.308 22.4952 27.9048C22.0934 27.5016 21.595 27.3 21 27.3C20.405 27.3 19.9066 27.5016 19.5048 27.9048C19.103 28.308 18.9014 28.8064 18.9 29.4C18.8986 29.9936 19.1002 30.4927 19.5048 30.8973C19.9094 31.3019 20.4078 31.5028 21 31.5ZM21 23.1C21.595 23.1 22.0941 22.8984 22.4973 22.4952C22.9005 22.092 23.1014 21.5936 23.1 21V12.6C23.1 12.005 22.8984 11.5066 22.4952 11.1048C22.092 10.703 21.5936 10.5014 21 10.5C20.4064 10.4986 19.908 10.7002 19.5048 11.1048C19.1016 11.5094 18.9 12.0078 18.9 12.6V21C18.9 21.595 19.1016 22.0941 19.5048 22.4973C19.908 22.9005 20.4064 23.1014 21 23.1ZM21 42C18.095 42 15.365 41.4484 12.81 40.3452C10.255 39.242 8.0325 37.7461 6.1425 35.8575C4.2525 33.9689 2.7566 31.7464 1.6548 29.19C0.553003 26.6336 0.00140266 23.9036 2.65823e-06 21C-0.00139734 18.0964 0.550202 15.3664 1.6548 12.81C2.7594 10.2536 4.2553 8.0311 6.1425 6.1425C8.0297 4.2539 10.2522 2.758 12.81 1.6548C15.3678 0.5516 18.0978 0 21 0C23.9022 0 26.6322 0.5516 29.19 1.6548C31.7478 2.758 33.9703 4.2539 35.8575 6.1425C37.7447 8.0311 39.2413 10.2536 40.3473 12.81C41.4533 15.3664 42.0042 18.0964 42 21C41.9958 23.9036 41.4442 26.6336 40.3452 29.19C39.2462 31.7464 37.7503 33.9689 35.8575 35.8575C33.9647 37.7461 31.7422 39.2427 29.19 40.3473C26.6378 41.4519 23.9078 42.0028 21 42ZM21 37.8C25.69 37.8 29.6625 36.1725 32.9175 32.9175C36.1725 29.6625 37.8 25.69 37.8 21C37.8 16.31 36.1725 12.3375 32.9175 9.0825C29.6625 5.8275 25.69 4.2 21 4.2C16.31 4.2 12.3375 5.8275 9.0825 9.0825C5.8275 12.3375 4.2 16.31 4.2 21C4.2 25.69 5.8275 29.6625 9.0825 32.9175C12.3375 36.1725 16.31 37.8 21 37.8Z" fill="#FE577F"/>
        </svg>
      </div>

      <!-- 標題 -->
      <div class="popup-title">{{ title }}</div>

      <!-- 描述文字 (可選) -->
      <div v-if="description" class="popup-description">{{ description }}</div>
    </div>
  </BasePopup>
</template>

<script>
import BasePopup from '@/components/Page/Web/PartnerMarketing/BasePopup.vue'

export default {
  name: 'ErrorPopup',
  components: { BasePopup },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '兌換失敗！'
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.error-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
</style>